import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/sidebarIcons/jozunaLogo.svg";
import "../styles/Sidebar.css";
import dashUnselected from "../assets/sidebarIcons/dashboardUnselection.svg";
import programHubUnselected from "../assets/sidebarIcons/programHubUnselection.svg";
import codeHubUnselected from "../assets/sidebarIcons/codeUnselection.svg";
import liveSessionUnselected from "../assets/sidebarIcons/liveUnselection.svg";
import assessmentUnselected from "../assets/sidebarIcons/assessmenUnselection.svg";
import calenderUnselected from "../assets/sidebarIcons/calenderUnselection.svg";
import interviewUnselected from "../assets/sidebarIcons/interviewUnselection.svg";
import recommendationUnselected from "../assets/sidebarIcons/recommandationUnselection.svg";
import programHover from "../assets/sidebarIcons/progamhubHover.svg";
import dashboardHover from "../assets/sidebarIcons/dashboardHover.svg";
import assessmentHover from "../assets/sidebarIcons/assessmentHover.svg";
import liveHover from "../assets/sidebarIcons/liveHover.svg";
import calenderHover from "../assets/sidebarIcons/calenderHover.svg";
import interviewHover from "../assets/sidebarIcons/interviewHover.svg";
import codeHover from "../assets/sidebarIcons/codeHover.svg";
import recommendationHover from "../assets/sidebarIcons/recommendationHover.svg";
import dashboardSelected from "../assets/sidebarIcons/dashboardSelected.svg";
import programSelected from "../assets/sidebarIcons/programHubSelected.svg";
import assessmentSelected from "../assets/sidebarIcons/assessmentSelected.svg";
import liveSelected from "../assets/sidebarIcons/liveSelected.svg";
import calenderSelected from "../assets/sidebarIcons/calendarSelected.svg";
import interviewSelected from "../assets/sidebarIcons/interviewSelection.svg";
import codeSelected from "../assets/sidebarIcons/codeSelection.svg";
import recommendationSelected from "../assets/sidebarIcons/recommandationSelected.svg";
import jozunaExpandedLogo from "../assets/sidebarIcons/jozunaExpandedLogo.svg";
import aboutHover from "../assets/sidebarIcons/aboutHover.svg";
import aboutSelected from "../assets/sidebarIcons/aboutSelected.svg";
import aboutUnselected from "../assets/sidebarIcons/aboutUnselection.svg";
import chatIcon from "../../chatbot/images/chatBotIcon.svg";
import whoAreWeUnselected from "../assets/sidebarIcons/whoWeAreUnselected.svg";
import whoAreWeSelected from "../assets/sidebarIcons/whoWeSelected.svg";
import whatsNewUnselected from "../assets/sidebarIcons/whatsNewUnselected.svg";
import whatsNewSelected from "../assets/sidebarIcons/whatsNewSelected.svg";
import ourServicesUnselected from "../assets/sidebarIcons/servicesUnselection.svg";
import ourServicesselected from "../assets/sidebarIcons/serviceSelected.svg";
import contactUnselecetd from "../assets/sidebarIcons/contactUnselect.svg";
import contactSelecetd from "../assets/sidebarIcons/contactSelected.svg";

import requestUnselected from "../assets/sidebarIcons/requestUnselected.svg";
import requestSelected from "../assets/sidebarIcons/requestUnselected.svg";
import accountSelected from "../assets/sidebarIcons/profileSelected.svg";
import accountUnselected from "../assets/sidebarIcons/profileUnselection.svg";
import settingsUnselected from "../assets/sidebarIcons/settingsUnselection.svg";
import settingsSelected from "../assets/sidebarIcons/settingsSelected.svg";
import newTabSelected from "../assets/sidebarIcons/newtabSelected.svg";
import newTabUnselected from "../assets/sidebarIcons/newTabBlack.svg";

import { createPortal } from "react-dom";
import { useRef } from "react";
import { MenuItem, SidebarProps } from "../data/interfaces/sideBarInterface";
import { SidebarItem } from "../../../features/sideBar/data/interface/SidemenuInterface";
import strings from "../../../utils/Strings";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import logoutSelected from "../assets/logoutwhite.svg";
import logoutUnselected from "../assets/power-off 1.svg";
import certificateSelected from "../assets/certficateWhite.svg";
import certificateUnselected from "../assets/Certificate.svg";

import galleryIcon from "../assets/sidebarIcons/galleryUnSelectedImg.png";
// import certificateUnselected from "../assets/Certificate.svg";
import gallerySelected from "../assets/sidebarIcons/gallerySelectedImg.svg";
import galleryHovered from "../assets/sidebarIcons/galleryHoveredImg.svg";
import TruncatedTextWithTooltip from "../../../features/inventory_dashboard/components/TruncatedTooltip";
import Logger from "../../../utils/Logger";
import { LocalStorage } from "../../../utils/Utils";
import {
  setAutoLogoutActive,
  setQuizComponentActive,
} from "../../recommendation/vedio-recommendation/data/redux/QuizLogoutRedux";
import { useAlert } from "../../../components/AlertContextComponent";
import { logActionEvent } from "../../../analytics/analytics_utils";
import analytics_strings from "../../../analytics/analytics_strings";
import { useApi } from "../../../service/ApiContext";
import { fetchSyncDashboard } from "../../../service/DashboardSyncService";
import { LogOutResponse } from "../data/response/LogOut_Response";
import LogoutClient from "../data/api/LogoutClient";
import { clearEvents } from "../../liveSessions/data/reducer/eventReducer";
import { clearPrograms } from "../../liveSessions/data/reducer/ProgramDetailReducer";
import { clearJozunaSelectedProgram } from "../../recommendation/vedio-recommendation/data/redux/JozunaDropdown";
import { clearSelectedProgram } from "../../learning_room/data/redux/DropdownSLice";
import {
  setSelectedProgram,
  setSelectedSubject,
  setHasJozunaSkills,
} from "../../dashboard/data/redux/GradedPopQuizRedux";
import { setSelectedProgram as setLearningRoomSelectedProgram } from "../../learning_room/data/redux/DropdownSLice";
import CertificateGenerator from "../../certficates/pages/CertificatePage";
import CertificateSelectedIcon from "../../../assets/images/certificates/Certificate Active.png";

import CertificateUnselectedIcon from "../../../assets/images/certificates/Certificate Inactive.png";
import { clearLRState } from "../../learning_room/data/redux/LearningRoomRedux";
import {
  setShowChatBotOnLogin,
  setChatBotMode,
} from "../../../store/networkListener";
import ChatBotIcon from "../../chatbot/pages/ChatBotIcon";
import chatBotExpanded from "../../chatbot/images/chatBotOpenSidebar.svg";

const SidebarVersionTwo: React.FC<SidebarProps> = ({
  children,
  isMobileOpen,
  toggleMobileMenu,
  logoUrl,
}) => {
  const [open, setOpen] = useState(false);
  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const programEnrolled = useSelector(
    (state: RootState) => state.programs.programs,
  );

  const { showAlert } = useAlert();
  const avatarLetter = profileData.first_name?.charAt(0).toUpperCase();
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState<"about" | "profile" | null>(
    null,
  );
  const [logoutClicked, setLogoutClick] = useState<boolean>(false);
  const navigate = useNavigate();
  const sidebarRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const aboutRef = useRef<HTMLDivElement>(null);
  const profileRef = useRef<HTMLDivElement>(null);
  const quizOverlayActive = useSelector(
    (state: RootState) => state.QuizLogout.quizOverlayActive,
  );
  const quizComponentActive = useSelector(
    (state: RootState) => state.QuizLogout.quizComponentActive,
  );
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      const clickedInsideDropdown =
        dropdownRef.current && dropdownRef.current.contains(target);

      const clickedOnAbout =
        aboutRef.current && aboutRef.current.contains(target);

      const clickedOnProfile =
        profileRef.current && profileRef.current.contains(target);

      if (!clickedInsideDropdown && !clickedOnAbout && !clickedOnProfile) {
        setOpenDropdown(null);

        //close sidebar if click is outside sidebar
        if (
          sidebarRef.current &&
          !sidebarRef.current.contains(target) &&
          !isMobileOpen
        ) {
          setOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMobileOpen]);
  useEffect(() => {
    const img = new Image();
    img.src = chatBotExpanded;
  }, []);
  const getPosition = (ref: React.RefObject<HTMLDivElement>) => {
    if (!ref.current) return { top: 0, left: 0 };

    const rect = ref.current.getBoundingClientRect();

    return {
      top: rect.top - 100,
      left: rect.right + 10, // space from sidebar
    };
  };
  const toggleDropdown = (type: "about" | "profile") => {
    setOpenDropdown((prev) => (prev === type ? null : type));
  };

  const openAboutDropdown = () => {
    if (aboutCloseTimeout.current) {
      clearTimeout(aboutCloseTimeout.current);
    }

    setOpenDropdown("about");
  };

  const closeAboutDropdown = () => {
    aboutCloseTimeout.current = setTimeout(() => {
      setOpenDropdown((prev) => (prev === "about" ? null : prev));
    }, 150);
  };

  const openProfileDropdown = () => {
    if (profileCloseTimeout.current) {
      clearTimeout(profileCloseTimeout.current);
    }

    setOpenDropdown("profile");
  };

  const closeProfileDropdown = () => {
    profileCloseTimeout.current = setTimeout(() => {
      setOpenDropdown((prev) => (prev === "profile" ? null : prev));
    }, 150);
  };
  const dispatch = useDispatch();

  // const [programEnrolled, setProgramEnrolled] = useState<boolean>(false);

  const api = useApi();
  const hasJozunaSkills = useSelector(
    (state: RootState) => state.advancedFilterGradedPopQuiz.hasJozunaSkills,
  );

  const isFetchingJozuna = React.useRef(false);

  useEffect(() => {
    if (hasJozunaSkills === null && !isFetchingJozuna.current) {
      isFetchingJozuna.current = true;
      fetchSyncDashboard(api)
        .then((res) => {
          if (res?.data) {
            const hasJozuna = (res.data.jozuna_score?.length ?? 0) > 0;
            dispatch(setHasJozunaSkills(hasJozuna));
          }
        })
        .catch((err) => {
          Logger.info("error checking jozuna score in sidebar", err);
        })
        .finally(() => {
          isFetchingJozuna.current = false;
        });
    }
  }, [hasJozunaSkills, api, dispatch]);

  const menuItems: SidebarItem[] = [
    {
      name: strings.sideMenu.stundentDashText,
      path: "/dashboard/student",
      icon: dashUnselected,
      selectedIcon: dashboardSelected,
      hoverIcon: dashboardHover,
    },
    {
      name: strings.sideMenu.programHub,
      path: "/dashboard/learning-room",
      icon: programHubUnselected,
      selectedIcon: programSelected,
      hoverIcon: programHover,
      showMenu: profileData.partner_institute === true ? true : false,
    },
    {
      name: strings.sideMenu.assessmentText,
      path: "/dashboard/assessment",
      icon: assessmentUnselected,
      selectedIcon: assessmentSelected,
      hoverIcon: assessmentHover,
    },
    {
      name: strings.sideMenu.questionBankTxt,
      path: profileData.partner_institute
        ? "/dashboard/recommendation/jozunaview"
        : "/dashboard/text-recommendation",
      icon: recommendationUnselected,
      selectedIcon: recommendationSelected,
      hoverIcon: recommendationHover,
      showMenu: hasJozunaSkills === false ? false : true,
    },
    {
      name: strings.sideMenu.calender,
      path: "/dashboard/programSchedule",
      icon: calenderUnselected,
      selectedIcon: calenderSelected,
      hoverIcon: calenderHover,
      showMenu: profileData.partner_institute === true ? true : false,
    },

    {
      name: strings.sideMenu.livesession,
      path: "/dashboard/livesession",
      icon: liveSessionUnselected,
      selectedIcon: liveSelected,
      hoverIcon: liveHover,

      showMenu:
        // process.env.REACT_APP_ENVIORNMENT !== "PRODUCTION" &&
        profileData.partner_institute === true ? true : false,
    },

    {
      name: "Code Edge",
      path: "/dashboard/codehub",
      icon: codeHubUnselected,
      selectedIcon: codeSelected,
      hoverIcon: codeHover,
      showMenu: profileData.codehub_enabled === true ? true : false,
    },
    {
      name: strings.sideMenu.interviewHub,
      path: strings.routing.interviewHub,
      icon: interviewUnselected,
      selectedIcon: interviewSelected,
      hoverIcon: interviewHover,
      showMenu: profileData.interviewhub_enabled === true ? true : false,
    },
    {
      name: "Gallery",
      path: "/dashboard/gallery",
      icon: galleryIcon,
      selectedIcon: galleryHovered,
      hoverIcon: gallerySelected,
      showMenu: programEnrolled.length > 0 ? true : false,
    },
  ];

  const showLabels = open || isMobileOpen;
  // const [activeDropdownItem, setActiveDropdownItem] = useState<string | null>(
  //   null,
  // );

  const aboutCloseTimeout = useRef<NodeJS.Timeout | null>(null);
  const profileCloseTimeout = useRef<NodeJS.Timeout | null>(null);
  const [isAboutHovered, setIsAboutHovered] = useState(false);
  // const isAboutActive =
  //   activeDropdownItem === "our-services" ||
  //   activeDropdownItem === "who-we-are" ||
  //   activeDropdownItem === "contact-us";
  const [isProfileHovered, setIsProfileHovered] = useState(false);
  // const isProfileActive =
  //   activeDropdownItem === "profile" ||
  //   activeDropdownItem === "certificates" ||
  //   logoutClicked;
  const isAboutActive = location.pathname === "/dashboard/our-services";

  const isProfileActive =
    location.pathname === "/dashboard/profile" ||
    location.pathname === "/dashboard/certificates" ||
    logoutClicked;
  let aboutIcon = aboutUnselected;

  if (isAboutActive) {
    aboutIcon = aboutSelected;
  } else if (isAboutHovered) {
    aboutIcon = aboutHover;
  }
  const userLogout = async () => {
    logActionEvent(analytics_strings.analytics_events.logoutButton, {
      candidate_id: userData.candidate_id,
    });
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      await api
        .post<LogOutResponse>(LogoutClient.logoutURL)
        .then((res) => {
          if (res?.data?.error === null) {
            LocalStorage.deleteAllLocalData();
            dispatch(clearEvents());
            dispatch(clearPrograms());
            dispatch(clearJozunaSelectedProgram());
            dispatch(clearSelectedProgram());
            dispatch(setSelectedSubject(null));
            dispatch(setSelectedProgram(null));
            navigate("/", { replace: true });
            // setTimeout(() => closeAssessmentCamera(), 1000);
            // closeAssessmentCamera()
          }
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
    }
  };
  // const handleMenuNavigation = (itemName: string) => {
  //   if (itemName === strings.sideMenu.programHub) {
  //     dispatch(clearLRState());
  //   }
  // };
  const handleMenuNavigation = (itemName: string) => {
    if (itemName === strings.sideMenu.programHub) {
      dispatch(setLearningRoomSelectedProgram(null));
      dispatch(clearLRState());
    }
  };
  return (
    <div className="cm-container">
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div className="cm-sidebar-overlay" onClick={toggleMobileMenu}></div>
      )}
      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`cm-sidebar ${open ? "cm-expanded" : "cm-collapsed"} ${isMobileOpen ? "cm-mobile-open" : ""}`}
        onMouseEnter={() => {
          if (!isMobileOpen) setOpen(true);
        }}
        onMouseLeave={() => {
          if (!isMobileOpen && !openDropdown) {
            setOpen(false);
          }
        }}
      >
        {/* Header */}
        <div className="cm-sidebar-header">
          {!showLabels ? (
            <div className="cm-logo-collapsed">
              <img src={logoUrl === null ? Logo : logoUrl} alt="logo" />
            </div>
          ) : (
            <div className="cm-logo-section">
              <img
                src={logoUrl === null ? jozunaExpandedLogo : logoUrl}
                alt="logo"
                className="cm-Expanded-logo-img"
              />
            </div>
          )}
        </div>

        <div className="cm-menu">
          {menuItems
            .filter((item) => item.showMenu !== false)
            .map((item) => {
              const isActive =
                location.pathname === item.path ||
                location.pathname.startsWith(item.path + "/");
              const isHovered = hoveredItem === item.name;

              let iconSrc = item.icon;

              if (isActive) {
                iconSrc = item.selectedIcon!;
              } else if (isHovered) {
                iconSrc = item.hoverIcon!;
              }

              return (
                <Link
                  key={item.name}
                  to={item.path}
                  onClickCapture={() => handleMenuNavigation(item.name)}
                  className={`cm-menu-item ${open ? "cm-expanded" : "cm-collapsed"} ${isActive ? "cm-active" : ""}`}
                  style={{ textDecoration: "none" }}
                  // onClick={() => isMobileOpen && toggleMobileMenu()}
                  onClick={() => {
                    handleMenuNavigation(item.name);

                    if (isMobileOpen) {
                      toggleMobileMenu();
                    }
                  }}
                  onMouseEnter={() => setHoveredItem(item.name)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <img src={iconSrc} alt={item.name} className="cm-icon" />

                  {showLabels && <span>{item.name}</span>}
                </Link>
              );
            })}
        </div>
        {/* Logout */}
        <div className="cm-logout">
          {/* <div
            id="sidebar-chatbot"
            className="sidebar-chatbot"
            onClick={() => {
              dispatch(setShowChatBotOnLogin(true));
              sessionStorage.removeItem("floatingBotHidden");
            }}
          >
            <img src={chatIcon} alt="" />
          </div> */}
          <div
            id="sidebar-chatbot"
            className="sidebar-chatbot"
            onClick={() => {
              dispatch(setChatBotMode("popup"));
              dispatch(setShowChatBotOnLogin(true));
            }}
          >
            <img
              src={showLabels ? chatBotExpanded : chatIcon}
              alt="Chatbot"
              className={
                showLabels ? "sidebar-chatbot-expanded" : "sidebar-chatbot-icon"
              }
            />
          </div>
          {/* About */}
          <div
            className={`cm-logout-item 
  ${isAboutHovered ? "cm-hovered" : ""} 
  ${isAboutActive ? "cm-active" : ""}`}
            ref={aboutRef}
            onMouseEnter={() => {
              setIsAboutHovered(true);
              openAboutDropdown();
            }}
            onMouseLeave={() => {
              setIsAboutHovered(false);
              closeAboutDropdown();
            }}
          >
            <img src={aboutIcon} className="cm-icon" alt="" />
            {showLabels && <span>About Jozuna</span>}
          </div>
          {/* About Dropdown */}
          {openDropdown === "about" &&
            createPortal(
              <div
                className="cm-dropdown"
                onMouseEnter={openAboutDropdown}
                onMouseLeave={closeAboutDropdown}
                style={getPosition(aboutRef)}
              >
                <div
                  className="cm-dropdown-item"
                  onMouseDown={(e) => {
                    e.preventDefault();

                    window.open(
                      process.env.REACT_APP_ABOUTUS_URL,
                      "_blank",
                      "noopener,noreferrer",
                    );

                    setOpenDropdown(null);

                    if (!isMobileOpen) {
                      setOpen(false);
                    }
                  }}
                >
                  <img
                    src={whoAreWeUnselected}
                    alt=""
                    className="dropdownIcon"
                  />
                  Who we are
                  <img
                    src={newTabUnselected}
                    alt=""
                    style={{
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </div>

                <div
                  className="cm-dropdown-item"
                  onMouseDown={(e) => {
                    e.preventDefault();

                    window.open(
                      process.env.REACT_APP_CONTACTUS_URL,
                      "_blank",
                      "noopener,noreferrer",
                    );

                    setOpenDropdown(null);

                    if (!isMobileOpen) {
                      setOpen(false);
                    }
                  }}
                >
                  <img
                    src={contactUnselecetd}
                    alt=""
                    className="dropdownIcon"
                  />
                  Contact Us
                  <img
                    src={newTabUnselected}
                    alt=""
                    style={{
                      height: "20px",
                      width: "20px",
                      marginLeft: "5px",
                    }}
                  />
                </div>
                <div
                  className={`cm-dropdown-item ${
                    location.pathname === "/dashboard/our-services"
                      ? "cm-dropdown-active"
                      : ""
                  }`}
                  onMouseDown={(e) => {
                    e.preventDefault();

                    setOpenDropdown(null);

                    if (!isMobileOpen) {
                      setOpen(false);
                    }

                    navigate("/dashboard/our-services");
                  }}
                >
                  <img
                    src={ourServicesUnselected}
                    alt=""
                    className="dropdownIcon"
                  />
                  Our Services
                </div>
                {/* <div className="cm-dropdown-item">
                  {" "}
                  <img
                    src={whatsNewUnselected}
                    alt=""
                    className="dropdownIcon"
                  />{" "}
                  What’s New
                </div> */}
              </div>,
              document.body,
            )}
          {/* Profile */}
          <div
            className={`cm-logout-item 
  ${isProfileHovered ? "cm-hovered" : ""} 
  ${isProfileActive ? "cm-active" : ""}`}
            ref={profileRef}
            onMouseEnter={() => {
              setIsProfileHovered(true);
              openProfileDropdown();
            }}
            onMouseLeave={() => {
              setIsProfileHovered(false);
              closeProfileDropdown();
            }}
          >
            <div className="cm-avatar">{avatarLetter}</div>

            {showLabels && (
              <span>
                {profileData.first_name} {profileData.last_name}
              </span>
            )}
          </div>
          <div
            style={{
              fontFamily: "Mazzard",
              fontSize: "10px",
              paddingLeft: "10px",
            }}
          >
            {showLabels
              ? `©${new Date().getFullYear()}. JOZUNA All rights reserved.`
              : `©${new Date().getFullYear()}.. `}{" "}
          </div>
          {/* Profile Dropdown */}
          {openDropdown === "profile" &&
            createPortal(
              <div
                className="cm-dropdown"
                onMouseEnter={openProfileDropdown}
                onMouseLeave={closeProfileDropdown}
                ref={dropdownRef}
                style={getPosition(profileRef)}
              >
                <div
                  className={`cm-dropdown-item ${
                    location.pathname === "/dashboard/profile"
                      ? "cm-dropdown-active"
                      : ""
                  }`}
                  onMouseDown={(e) => {
                    e.preventDefault();

                    setOpenDropdown(null);

                    if (!isMobileOpen) {
                      setOpen(false);
                    }

                    navigate("/dashboard/profile");
                  }}
                >
                  <img
                    src={
                      location.pathname === "/dashboard/profile" &&
                      !logoutClicked
                        ? accountSelected
                        : accountUnselected
                    }
                    alt=""
                    className="dropdownIcon"
                  />
                  My Account
                </div>
                <div
                  className={`cm-dropdown-item ${
                    location.pathname === "/dashboard/certificates"
                      ? "cm-dropdown-active"
                      : ""
                  }`}
                  onMouseDown={(e) => {
                    e.preventDefault();

                    setOpenDropdown(null);

                    if (!isMobileOpen) {
                      setOpen(false);
                    }

                    navigate("/dashboard/certificates");
                  }}
                >
                  {" "}
                  <img
                    src={
                      location.pathname === "/dashboard/certificates"
                        ? certificateSelected
                        : certificateUnselected
                    }
                    alt=""
                    className="dropdownIcon"
                  />
                  My Certificates
                </div>
                <div
                  className={`cm-dropdown-item ${
                    logoutClicked ? "cm-dropdown-active" : ""
                  }`}
                  onClick={() => {
                    setOpenDropdown(null);
                    setLogoutClick(true);
                    setOpenDropdown(null);

                    if (quizOverlayActive) {
                      dispatch(setQuizComponentActive(true));
                    } else {
                      showAlert({
                        show: true,
                        title: "Logout",
                        message: strings.sideMenu.logoutString,
                        button1Text: "OK",
                        button2Text: "Cancel",
                        alertType: "success",
                        onlyNeedOneButton: false,
                        btn1onPressed: () => {
                          userLogout();
                        },
                        btn2onPressed: () => {
                          setLogoutClick(false);
                        },
                        btn2close: true,
                      });
                    }
                  }}
                >
                  <img
                    src={logoutClicked ? logoutSelected : logoutUnselected}
                    alt=""
                    className="dropdownIcon"
                  />
                  Logout
                </div>
              </div>,
              document.body,
            )}
        </div>
      </div>
      {/* Content Area */}
      <div
        className={`cm-content ${
          open ? "sidebar-expanded" : "sidebar-collapsed"
        }`}
      >
        {children}
        {location.pathname.startsWith("/dashboard") &&
          !location.pathname.startsWith("/dashboard/assessment") && (
            <ChatBotIcon />
          )}
      </div>{" "}
    </div>
  );
};

export default SidebarVersionTwo;
